import { c as _c } from "react/compiler-runtime";
import { Avatar, Button, Tag } from '@systemeio/components';
import { ArrowDownIcon } from '@systemeio/icons';
import { AffiliateDashboardLeadOptionSource } from 'modules/affiliate-dashboard/components/affiliate-dashboard-lead-option-source';
import { useAffiliateDashboardLeads } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-leads';
import { AffiliateDashboardFilterInterface, AffiliateDashboardFilterWithTagInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardLeadOptionInterface, AffiliateDashboardLeadsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-leads-interface';
import React, { useEffect, useState } from 'react';
import { FormSelect } from 'shared/components';
import ListingLayout from 'shared/components/listing-layout';
import { RelativeTime } from 'shared/components/relative-time';
import { MobileCardHeader } from 'shared/components/table/components/mobile-card-header';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
import { twJoin } from 'tailwind-merge';
interface AffiliateDashboardLeadsProps {
  mainFilter: AffiliateDashboardFilterInterface;
  tagsData: SelectorDataInterface<TagId>[] | undefined;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardLeads = t0 => {
  const $ = _c(83);
  const {
    mainFilter,
    tagsData,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    setFirstPage
  } = usePagination(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [opened, setOpened] = useState(t1);
  let t2;
  if ($[1] !== mainFilter) {
    t2 = {
      ...mainFilter,
      affiliateTag: undefined
    };
    $[1] = mainFilter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [filterWithTag, setFilterWithTag] = useState(t2);
  let t3;
  if ($[3] !== setFirstPage) {
    t3 = tagId => {
      setFilterWithTag(prev => ({
        ...prev,
        affiliateTag: tagId
      }));
      setFirstPage();
    };
    $[3] = setFirstPage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const changeTag = t3;
  let t4;
  let t5;
  if ($[5] !== mainFilter) {
    t4 = () => {
      setFilterWithTag(prev_0 => ({
        ...prev_0,
        ...mainFilter
      }));
    };
    t5 = [mainFilter];
    $[5] = mainFilter;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== setFirstPage) {
    t6 = () => {
      setFirstPage();
    };
    $[8] = setFirstPage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== mainFilter || $[11] !== setFirstPage) {
    t7 = [mainFilter, setFirstPage];
    $[10] = mainFilter;
    $[11] = setFirstPage;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useDidUpdateEffect(t6, t7);
  let t8;
  if ($[13] !== filterWithTag || $[14] !== limit || $[15] !== pagination) {
    t8 = {
      filter: filterWithTag,
      pagination,
      limit
    };
    $[13] = filterWithTag;
    $[14] = limit;
    $[15] = pagination;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const {
    affiliateLeads,
    counter
  } = useAffiliateDashboardLeads(t8);
  let t10;
  let t9;
  if ($[17] !== affiliateLeads) {
    t9 = () => {
      if (affiliateLeads) {
        setOpened(affiliateLeads.items.reduce(_temp, {}));
      }
    };
    t10 = [affiliateLeads];
    $[17] = affiliateLeads;
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== setMainFilter) {
    t11 = lead => setMainFilter(prev_1 => ({
      ...prev_1,
      vendorId: lead.contact.user.id
    }));
    $[20] = setMainFilter;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const filterByVendor = t11;
  let t12;
  if ($[22] !== t) {
    t12 = t("dashboard.affiliate_dashboard.vendor");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== filterByVendor) {
    t13 = lead_0 => <div className="flex items-center gap-1.5 truncate"><VendorAvatarButton lead={lead_0} onClick={() => filterByVendor(lead_0)} /><div className="flex w-full flex-col truncate"><span className="truncate">{lead_0.contact.user.affiliateProgramBrandName}</span><span className="block truncate">{lead_0.contactEmail}</span></div></div>;
    $[24] = filterByVendor;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13) {
    t14 = {
      key: "vendor",
      header: t12,
      widthPercent: 30,
      onRender: t13
    };
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("dashboard.affiliate_dashboard.source_url");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== changeTag || $[32] !== opened) {
    t16 = lead_1 => <AffiliateReferOptions opened={Boolean(opened[lead_1.contact.id])} changeTag={changeTag} lead={lead_1} />;
    $[31] = changeTag;
    $[32] = opened;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = {
      key: "sourceUrl",
      header: t15,
      widthPercent: 50,
      onRender: t16
    };
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("global.date");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== opened) {
    t19 = lead_2 => <AffiliateDateOptions lead={lead_2} opened={Boolean(opened[lead_2.contact.id])} setOpened={setOpened} />;
    $[39] = opened;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18 || $[42] !== t19) {
    t20 = {
      key: "date",
      header: t18,
      widthPercent: 20,
      onRender: t19
    };
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t14 || $[45] !== t17 || $[46] !== t20) {
    t21 = [t14, t17, t20];
    $[44] = t14;
    $[45] = t17;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  const columns = t21;
  let t22;
  if ($[48] !== t) {
    t22 = t("dashboard.affiliate.leads.title");
    $[48] = t;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== mainFilter) {
    t23 = {
      ...mainFilter,
      affiliateTag: undefined
    };
    $[50] = mainFilter;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== filterWithTag || $[53] !== t23) {
    t24 = {
      filter: filterWithTag,
      setFilter: setFilterWithTag,
      defaultFilters: t23
    };
    $[52] = filterWithTag;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t || $[56] !== tagsData) {
    t25 = [{
      field: "affiliateTag",
      onRender: (value, onChange) => <FormSelect placeholder={t("dashboard.affiliate_dashboard.any_tag")} value={value} data={tagsData} onChange={onChange} />
    }];
    $[55] = t;
    $[56] = tagsData;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== setPagination || $[59] !== t24 || $[60] !== t25) {
    t26 = {
      filterer: t24,
      setPagination,
      filterable: t25
    };
    $[58] = setPagination;
    $[59] = t24;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== limit || $[63] !== setLimit) {
    t27 = {
      limit,
      setLimit
    };
    $[62] = limit;
    $[63] = setLimit;
    $[64] = t27;
  } else {
    t27 = $[64];
  }
  let t28;
  if ($[65] !== pagination || $[66] !== setPagination) {
    t28 = {
      pagination,
      setPagination
    };
    $[65] = pagination;
    $[66] = setPagination;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== changeTag || $[69] !== filterByVendor || $[70] !== opened) {
    t29 = lead_3 => <AffiliateMobileRow lead={lead_3} opened={Boolean(opened[lead_3.contact.id])} changeTag={changeTag} setOpened={setOpened} onVendorClick={() => filterByVendor(lead_3)} />;
    $[68] = changeTag;
    $[69] = filterByVendor;
    $[70] = opened;
    $[71] = t29;
  } else {
    t29 = $[71];
  }
  let t30;
  if ($[72] !== affiliateLeads || $[73] !== columns || $[74] !== t27 || $[75] !== t28 || $[76] !== t29) {
    t30 = <Table getRowId={_temp2} data={affiliateLeads} columns={columns} limiter={t27} paginator={t28} renderMobileRow={t29} />;
    $[72] = affiliateLeads;
    $[73] = columns;
    $[74] = t27;
    $[75] = t28;
    $[76] = t29;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== counter || $[79] !== t22 || $[80] !== t26 || $[81] !== t30) {
    t31 = <ListingLayout counter={counter} title={t22} filterData={t26}>{t30}</ListingLayout>;
    $[78] = counter;
    $[79] = t22;
    $[80] = t26;
    $[81] = t30;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  return t31;
};
const VendorAvatarButton = t0 => {
  const $ = _c(7);
  const {
    lead,
    onClick
  } = t0;
  let t1;
  if ($[0] !== lead.contact.user.affiliateProgramBrandName || $[1] !== lead.contact.user.avatar || $[2] !== lead.contact.user.email) {
    t1 = <Avatar size="md" alt={lead.contact.user.affiliateProgramBrandName} src={lead.contact.user.avatar} displayName={lead.contact.user.affiliateProgramBrandName} email={lead.contact.user.email} />;
    $[0] = lead.contact.user.affiliateProgramBrandName;
    $[1] = lead.contact.user.avatar;
    $[2] = lead.contact.user.email;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onClick || $[5] !== t1) {
    t2 = <button onClick={onClick} className="focus-visible:focus-ring-primary h-[32px] w-[32px] shrink-0 rounded-full outline-hidden">{t1}</button>;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const ExpandOptinsButton = t0 => {
  const $ = _c(14);
  const {
    lead,
    opened,
    setOpened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("global.more");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== lead || $[3] !== setOpened) {
    t2 = () => setOpened(prev => ({
      ...prev,
      [lead.contact.id]: !prev[lead.contact.id]
    }));
    $[2] = lead;
    $[3] = setOpened;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = opened && "rotate-180";
  let t4;
  if ($[5] !== t3) {
    t4 = twJoin("transition-base", t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <ArrowDownIcon className={t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== opened || $[10] !== t1 || $[11] !== t2 || $[12] !== t5) {
    t6 = <Button aria-expanded={opened} aria-label={t1} className="bg-bg-accent-active hover:bg-control-active-hover text-icon-on border-transparent" onClick={t2} size="icon-xs" variant="round">{t5}</Button>;
    $[9] = opened;
    $[10] = t1;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
const AffiliateMobileRow = t0 => {
  const $ = _c(25);
  const {
    lead,
    changeTag,
    opened,
    setOpened,
    onVendorClick
  } = t0;
  let t1;
  if ($[0] !== lead.affiliateOptins || $[1] !== opened) {
    t1 = opened ? lead.affiliateOptins : lead.affiliateOptins.slice(0, 1);
    $[0] = lead.affiliateOptins;
    $[1] = opened;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const visibleOptins = t1;
  let t2;
  if ($[3] !== lead || $[4] !== onVendorClick) {
    t2 = <VendorAvatarButton lead={lead} onClick={onVendorClick} />;
    $[3] = lead;
    $[4] = onVendorClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== lead || $[7] !== opened || $[8] !== setOpened) {
    t3 = lead.affiliateOptins.length > 1 && <ExpandOptinsButton lead={lead} opened={opened} setOpened={setOpened} />;
    $[6] = lead;
    $[7] = opened;
    $[8] = setOpened;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== lead.contact.user.affiliateProgramBrandName || $[11] !== lead.contactEmail || $[12] !== t2 || $[13] !== t3) {
    t4 = <MobileCardHeader icon={t2} title={lead.contact.user.affiliateProgramBrandName} subtitle={lead.contactEmail} action={t3} />;
    $[10] = lead.contact.user.affiliateProgramBrandName;
    $[11] = lead.contactEmail;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== changeTag || $[16] !== visibleOptins) {
    let t6;
    if ($[18] !== changeTag) {
      t6 = (optin, idx) => <AffiliateMobileOptionItem key={idx} item={optin} changeTag={changeTag} />;
      $[18] = changeTag;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    t5 = visibleOptins.map(t6);
    $[15] = changeTag;
    $[16] = visibleOptins;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[20] !== t5) {
    t6 = <ul className="flex flex-col gap-3">{t5}</ul>;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t4 || $[23] !== t6) {
    t7 = <div className="flex flex-col gap-3">{t4}{t6}</div>;
    $[22] = t4;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};
const AffiliateMobileOptionItem = t0 => {
  const $ = _c(14);
  const {
    item,
    changeTag
  } = t0;
  let t1;
  if ($[0] !== item.sourceText || $[1] !== item.sourceUrl) {
    t1 = <AffiliateDashboardLeadOptionSource sourceUrl={item.sourceUrl} sourceText={item.sourceText} />;
    $[0] = item.sourceText;
    $[1] = item.sourceUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== changeTag || $[4] !== item.affiliateTag) {
    t2 = item.affiliateTag && <Tag render={<button type="button" />} size="sm" onClick={() => item.affiliateTag && changeTag(item.affiliateTag.id)} className="focus-visible:focus-ring-primary outline-hidden">{item.affiliateTag.name}</Tag>;
    $[3] = changeTag;
    $[4] = item.affiliateTag;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex items-center gap-3">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== item.date) {
    t4 = <span className="w-full truncate"><RelativeTime time={item.date} /></span>;
    $[9] = item.date;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <li className="flex flex-col">{t3}{t4}</li>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
const AffiliateReferOptions = t0 => {
  const $ = _c(9);
  const {
    lead,
    changeTag,
    opened
  } = t0;
  let t1;
  if ($[0] !== changeTag || $[1] !== lead.affiliateOptins || $[2] !== opened) {
    let t2;
    if ($[4] !== changeTag || $[5] !== opened) {
      t2 = (opt, idx) => {
        if (idx === 0) {
          return <AffiliateReferOptionItem key={idx} item={opt} changeTag={changeTag} />;
        } else {
          if (opened) {
            return <AffiliateReferOptionItem key={idx} item={opt} changeTag={changeTag} />;
          }
        }
      };
      $[4] = changeTag;
      $[5] = opened;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = lead.affiliateOptins.map(t2);
    $[0] = changeTag;
    $[1] = lead.affiliateOptins;
    $[2] = opened;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ul className="flex w-full flex-col gap-1.5 truncate">{t1}</ul>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
const AffiliateDateOptions = t0 => {
  const $ = _c(14);
  const {
    lead,
    opened,
    setOpened
  } = t0;
  let t1;
  if ($[0] !== lead.affiliateOptins || $[1] !== opened) {
    let t2;
    if ($[3] !== opened) {
      t2 = (opt, idx) => {
        if (idx === 0) {
          return <AffiliateDateOptionItem key={idx} item={opt} />;
        } else {
          if (opened) {
            return <AffiliateDateOptionItem key={idx} item={opt} />;
          }
        }
      };
      $[3] = opened;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = lead.affiliateOptins.map(t2);
    $[0] = lead.affiliateOptins;
    $[1] = opened;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="flex w-full flex-col gap-1.5 truncate">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== lead || $[8] !== opened || $[9] !== setOpened) {
    t3 = lead.affiliateOptins.length > 1 && <ExpandOptinsButton lead={lead} opened={opened} setOpened={setOpened} />;
    $[7] = lead;
    $[8] = opened;
    $[9] = setOpened;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex items-center justify-between gap-5 truncate">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
const AffiliateReferOptionItem = t0 => {
  const $ = _c(9);
  const {
    item,
    changeTag
  } = t0;
  let t1;
  if ($[0] !== item.sourceText || $[1] !== item.sourceUrl) {
    t1 = <AffiliateDashboardLeadOptionSource sourceUrl={item.sourceUrl} sourceText={item.sourceText} />;
    $[0] = item.sourceText;
    $[1] = item.sourceUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== changeTag || $[4] !== item.affiliateTag) {
    t2 = item.affiliateTag && <Tag render={<button type="button" />} size="sm" onClick={() => item.affiliateTag && changeTag(item.affiliateTag.id)} className="focus-visible:focus-ring-primary outline-hidden">{item.affiliateTag.name}</Tag>;
    $[3] = changeTag;
    $[4] = item.affiliateTag;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <li className="flex items-center justify-between gap-3">{t1}{t2}</li>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const AffiliateDateOptionItem = t0 => {
  const $ = _c(2);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.date) {
    t1 = <li><span className="w-full truncate"><RelativeTime time={item.date} /></span></li>;
    $[0] = item.date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default AffiliateDashboardLeads;
function _temp(acc, cur) {
  return {
    ...acc,
    [cur.contact.id]: false
  };
}
function _temp2(row) {
  return row.contact.id;
}